import { render, staticRenderFns } from "./Register_ConfirmEmail.vue?vue&type=template&id=1cfcab68&scoped=true"
import script from "./Register_ConfirmEmail.vue?vue&type=script&lang=ts"
export * from "./Register_ConfirmEmail.vue?vue&type=script&lang=ts"
import style0 from "./Register_ConfirmEmail.vue?vue&type=style&index=0&id=1cfcab68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfcab68",
  null
  
)

export default component.exports